import React from 'react';

const SVG = ({
  id = 'docDownloadIcon',
  style = {},
  fill = '#f8f8f8',
  className = '',
  viewBox = '0 0 24 24',
  title = 'DocDownloadIcon',
}) => (
  <svg
    fill={fill}
    style={style}
    className={`svg ${className}`}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <style>
        {`
          .svg-docDownloadIcon-1 { fill: none; }
          .${id}.svg-fill-docDownloadIcon { fill: ${fill}; }
        `}
      </style>
    </defs>
    <title>{title}</title>
    <g id="Group_4959">
      <g id="Group_4958">
        <path fill="none" d="M0 0h24v24H0z" />
        <path
          fill="#9aa0ae"
          d="M19.35 10.04a7.492 7.492 0 0 0-14-2A6 6 0 0 0 6 20h13a4.986 4.986 0 0 0 .35-9.96zM19 18H6a4 4 0 0 1-.44-7.97l1.07-.11.5-.95a5.487 5.487 0 0 1 10.26 1.46l.3 1.5 1.53.11A2.983 2.983 0 0 1 19 18zm-5.55-8h-2.9v3H8l4 4 4-4h-2.55z"
        />
      </g>
    </g>
  </svg>
);

export default SVG;
